import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MessagingService } from 'src/app/providers/messaging.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SharedService } from 'src/app/providers/shared.service';
import { AddServiceTemplateItemComponent } from 'src/app/shared/components/add-service-template-item/add-service-template-item.component';
import { AddServiceTimingsComponent } from 'src/app/shared/components/add-service-timings/add-service-timings.component';
import { AddServiceComponent } from 'src/app/shared/components/add-service/add-service.component';
import { RenewBusinessComponent } from 'src/app/shared/components/renew-business/renew-business.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-employee-only-my-attendance',
  templateUrl: './employee-only-my-attendance.component.html',
  styleUrls: ['./employee-only-my-attendance.component.scss']
})
export class EmployeeOnlyMyAttendanceComponent implements OnInit, OnDestroy {
  entityHashId: string = '';
  employeeHash: string = '';
  serviceType: string = '';
  public loader: boolean = false;
  serviceTimings: any = []
  finalServiceTimings: any = [{
    dayName: "Entity Monthly Plan",
    openTime: "28 Nov, 2023",
    closeTime: "27 Dec, 2023",
    status: "Active"
  }]
  currentPlan: any[] = [];
  dutyLogsData: any = []
  private _apiSubscription: Subscription;
  datalength!: number
  public page: number = 1;
  searchString: FormControl = new FormControl('');

  daysOfWeek = [
    { day: 1, name: 'Sunday' },
    { day: 2, name: 'Monday' },
    { day: 3, name: 'Tuesday' },
    { day: 4, name: 'Wednesday' },
    { day: 5, name: 'Thursday' },
    { day: 6, name: 'Friday' },
    { day: 7, name: 'Saturday' }
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
  
    {
      columnName: this.translateService.instant('duty_logs.column_headers.type'),
      columnProperty: "entry_status"
    },
    
    {
      columnName: this.translateService.instant('duty_logs.column_headers.date'),
      columnProperty: "duty_date"
    },
    {
      columnName: this.translateService.instant('duty_logs.column_headers.location'),
      columnProperty: "address"
    }
  ];
  constructor(private translateService: TranslateService,private _navService: NavigationService, private route: ActivatedRoute, private _apiService: ApiService, private _modelRef: MatDialog, private sharedService: SharedService, private loaderservice: LoaderServiceService,private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,private sanitizer: DomSanitizer) { 
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_DUTY_LOG){
        this.dutyLogsData = []
        if(resData.result){
          this.datalength = resData.result ? resData.result[0].totalCount : 0
          resData.result.forEach((element:any) => {
            element.duty_date = element.duty_time
            if(element.entry_type == 1){
              element.entry_status = "In"
            }
            else if(element.entry_type == 0){
              element.entry_status = 'Out'
            }
            this.dutyLogsData.push(element)
          });
         
        }
        this.loader = false;
        this.loaderservice.showLoader = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SUBSCRIPTION_INFO){ 
        // alert("calling from plan and renew")
        
        if(resData.result){
          // this.ngOnInit()
          this.loaderservice.showLoader = false
          window.location.reload()
        }
       }
       this.translateService.onLangChange.subscribe(() => {
        // Update your column headers when the language changes
        this.updateColumnHeaders();
      });
      
    });
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column,index) => {
      let data = [
        "type",
        "date",
        "location",
      ]
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(`duty_logs.column_headers.${data[index]}`);
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  ngOnInit(): void {
 
   
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash
      this.employeeHash = data.employeeHash
    })
    this.loader = true;
    this.loaderservice.showLoader = true
    this._apiService.getEmployeeDutyLog(this.entityHashId, this.employeeHash, '25', this.page.toString())

    // if(this.serviceType == '0'){
    //   this.loaderservice.showLoader = true
    //   this._apiService.getHomeServiceTimeDetails(this.entityHashId)
    // }
    // else if(this.serviceType == '1'){
    //   this.loaderservice.showLoader = true
    //   this._apiService.getShopEntityTimeDetails(this.entityHashId)
    // }


    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.loader = true;
    //   this._apiService.getServices(this.entityHashId)
    // });

  }

  openGoogleMaps(rowvalue:any): void {
    // Construct the Google Maps URL with the provided coordinates
    const mapUrl = `https://www.google.com/maps?q=${rowvalue.lat},${rowvalue.lng}`;
  
    // Sanitize the URL to make it safe for opening in a new tab
    // const sanitizedUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(mapUrl);
    // console.log(sanitizedUrl.toString());
    
    // Open a new tab with the Google Maps URL
    window.open(mapUrl, '_blank');
  }
  
  

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService(){
this._modelRef.open(AddServiceComponent, {
      width: '700px',
      data: {
        title: 'Add service',
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
  }
  onCreateNewServiceFromTemplate(){
this._modelRef.open(AddServiceTemplateItemComponent, {
      width: '1000px',
      data: {
        title: 'Add service From Template',
        ref: this._modelRef,
      },
    });
  }

  openAddTime(rowvalue:any){
    rowvalue.serviceType = this.serviceType
    rowvalue.entityHash = this.entityHashId
    this._modelRef.open(AddServiceTimingsComponent, {
      width: '500px',
      data: {
        title: 'Add service timing',
        ref: this._modelRef,
        data: rowvalue
      },
    });
  }

  removeTime(rowvalue:any){
    if(this.serviceType == '0'){
      let data = {
        homeServiceTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this._apiService.updateHomeServiceTimeInfo(
        this.entityHashId,
        data
      );
    }
    else if(this.serviceType == '1'){
      let data = {
        entityTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this._apiService.updateEntityShopTimeInfo(
        this.entityHashId,
        data
      );
    }
  }

  deactivateService(rowvalue: any){
console.log(rowvalue);
let metadata = {
  serviceTypeInfo: {
    hash_id: rowvalue.hash_id,
    status: 7
  }
}

this._apiService.addUpdateServiceType(metadata, this.entityHashId)

// setTimeout(() => {
//   this.ngOnInit();
// }, 1500);

  }

  activateService(rowvalue:any){
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1
      }
    }
    
    this._apiService.addUpdateServiceType(metadata, this.entityHashId)
    
    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue:any){
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1
      }
    }

    this._apiService.addUpdateServiceType(metadata, this.entityHashId)
    
    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue:any){
    this._modelRef.open(AddServiceComponent, {
      width: '700px',
      data: {
        title: 'Add service',
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  
  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    this._apiService.getEmployeeDutyLog(this.entityHashId, this.employeeHash, '25', this.page.toString())
  }

  firstTimeBelow3:boolean = false;

  searchServiceData(){
    if(this.searchString.value.length >= 3){
      this.firstTimeBelow3 = true
      this.page = 1
      this._apiService.getServiceDataByKeyword(this.entityHashId,this.page, this.searchString.value)
    }
    else{
      if (this.firstTimeBelow3) {
      this.firstTimeBelow3 = false
      this.page = 1
      // //this._apiService.getServices(this.entityHashId, this.page.toString())
      }
    }
  }

  reset(){
    this.searchString.reset()
    this.page = 1
    // //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  renewBusiness(){
    this._modelRef.open(RenewBusinessComponent, {
      width: '500px',
      data: {
        title: 'Recharge Business',
        ref: this._modelRef,
        data: this.entityHashId
      },
    });
}

  convertTo12HourFormat(timeString:any) {
    
    const [hours, minutes] = timeString.split(':');
    let period = 'AM';
    let hour = parseInt(hours, 10);
  
    if (hour >= 12) {
      period = 'PM';
      if (hour > 12) {
        hour -= 12;
      }
    }
  
    return `${hour.toString().padStart(2, '0')}:${minutes} ${period}`;
  }


}


